export default "__VITE_ASSET__c08431d9__"